export const platformSystemId =
  process.env.REACT_APP_PLATFORM_SYSTEM_ID || 'oktonbank';

export const platformBaseUrl = (
  process.env.REACT_APP_PLATFORM_API_URL || ''
).trim();
